import { isNil } from 'lodash-es';
const _checkEmptyParameters = (data) => {
    const pParams = ['p1', 'p2', 'p3', 'p4', 'p5', 'p6', 'p7', 'p8', 'p9', 'p10'];
    return !pParams.some((p) => !isNil(data[p]) && data[p] !== '');
};
export const prepareExtraParametersP = (data) => {
    if (_checkEmptyParameters(data)) {
        return null;
    }
    return `p1: ${data.p1 || '-'},
p2: ${data.p2 || '-'},
p3: ${data.p3 || '-'},
p4: ${data.p4 || '-'},
p5: ${data.p5 || '-'},
p6: ${data.p6 || '-'},
p7: ${data.p7 || '-'},
p8: ${data.p8 || '-'},
p9: ${data.p9 || '-'},
p10: ${data.p10 || '-'}`;
};
